export default __webpack_public_path__ + "static/media/whatsappWhite.40e7d1ef.svg";